export interface BmwRsConfiguration {
    locale: string;
    range: string;
    modelCode: string;
    options: string[];
}

export function parseBmwRsUrl(url: string): BmwRsConfiguration | null {
    try {
        const urlObj = new URL(url);

        const pathSegments = urlObj.pathname.split('/').filter(segment => segment.length > 0);

        if (pathSegments.length < 4 || pathSegments[1] !== 'configure') {
            return null;
        }

        const [locale, , range, modelCode, optionsString = ''] = pathSegments;
        const options = optionsString.length > 0 ? optionsString.split(',') : [];

        return {
            locale,
            range,
            modelCode,
            options
        };
    } catch (error) {
        return null;
    }
}
